import { baseApi } from '@ibk/shared-config';
export const scheduleApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        posCancelSchedule: builder.mutation({
            query: ({ id }) => ({
                url: `/v1/schedule/${id}/cancel`,
                method: 'POST',
                forceSelectedAccountInfoAccountId: true,
                forceAccountantApiBaseUrl: true,
            }),
        }),
    }),
});
export const { usePosCancelScheduleMutation } = scheduleApi;
